import { defineConfig } from './config.default'

export default defineConfig({
	environment: 'staging',
	
	signature: {
		validate_pages: false
	},
	
	maintenance: {
		check_on_save: true,
		message: undefined
	},
})